import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Spinner } from "react-bootstrap";
import { getTicketsCount } from "../../../Service/AllTicketServiceAPI";


const TicketnonTechDashboard = () => {
  const [ticketData, setTicketData] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchTicketData = async () => {
    try {
      const response = await getTicketsCount();
      setTicketData(response.data);
    } catch (error) {
      console.error("Failed to fetch ticket data:", error);
      setTicketData(null); 
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTicketData();
  }, []);

  const renderCard = (count = 0, label) => (
    <Col xs={6} md={3} className="d-flex flex-column align-items-center mb-4">
      <Card
        style={{
          border: "2px solid #0d6efd",
          borderRadius: "12px",
          width: "100px",
          height: "70px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Card.Body className="p-2 d-flex align-items-center justify-content-center">
          <h4 className="mb-0">{count ?? 0}</h4>
        </Card.Body>
      </Card>
     <div style={{ marginTop: "5px", fontSize: "16px", textAlign: "center", fontWeight: "bold" }}>
        {label}
      </div>
    </Col>
  );

  if (loading) {
    return (
      <div className="text-center mt-5">
        <Spinner animation="border" variant="primary" />
        <p>Loading ticket data...</p>
      </div>
    );
  }

  if (!ticketData || Object.keys(ticketData).length === 0) {
    return (
      <div className="text-center mt-5">
        <p>No ticket available....</p>
      </div>
    );
  }

  return (
    <Container
      fluid
      className="p-4"
      style={{ backgroundColor: "#e8e8e8", minHeight: "60vh" }}
    >

      <Row className="mb-4 justify-content-center">
        <Col xs="auto">
          <h3
            style={{
              background: "#008B8B",
              color: "#fff",
              padding: "8px 10px",
              borderRadius: "8px",
              boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
            }}
          >
            Non-Technical Dashboard
          </h3>
        </Col>
      </Row>

  
      <Row className="mb-4 justify-content-center">
        <Col xs="auto">
          <div
            style={{
              background: "#dcdcdc",
              padding: "6px 15px",
              border: "1px solid #ccc",
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            SLA Tickets Count Status
          </div>
        </Col>
      </Row>
      <Row className="justify-content-center">
        {renderCard(ticketData?.slaOpen ?? 0, "Open SLA Tickets")}
        {renderCard(ticketData?.slaClose ?? 0, "Close SLA Tickets")}
        {renderCard(ticketData?.slaInprogress ?? 0, "In Progress SLA")}
        {renderCard(ticketData?.slaTotal ?? 0, "Total SLA Tickets")}
      </Row>

      {/* Non-SLA Section */}
      <Row className="mt-4 mb-5 justify-content-center">
        <Col xs="auto">
          <div
            style={{
              background: "#dcdcdc",
              padding: "6px 15px",
              border: "1px solid #ccc",
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            Non SLA Ticket Count Status
          </div>
        </Col>
      </Row>
      <Row className="justify-content-center">
        {renderCard(ticketData?.nonSlaOpen ?? 0, "Open Non SLA Tickets")}
        {renderCard(ticketData?.nonSlaClose ?? 0, "Close Non SLA Tickets")}
        {renderCard(ticketData?.nonSlaInprogress ?? 0, "In Progress Non SLA")}
        {renderCard(ticketData?.nonSlaTotal ?? 0, "Total Non SLA Tickets")}
      </Row>

      {/* OMC Section */}
      <Row className="mt-4 mb-5 justify-content-center">
        <Col xs="auto">
          <div
            style={{
              background: "#dcdcdc",
              padding: "6px 15px",
              border: "1px solid #ccc",
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            OMC Ticket Count Status
          </div>
        </Col>
      </Row>
      <Row className="justify-content-center">
        {renderCard(ticketData?.omcPending ?? 0, "OMC Pending")}
        {renderCard(ticketData?.omcApproved ?? 0, "OMC Approved")}
      </Row>
 
    </Container>
  );
};

export default TicketnonTechDashboard;


